"use strict";

var _classCallCheck = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _globalRegistry = _interopRequireDefault(require("./globalRegistry"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LoaderResolver =
/*#__PURE__*/
function () {
  function LoaderResolver(gl) {
    var registry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _globalRegistry.default;

    _classCallCheck(this, LoaderResolver);

    _defineProperty(this, "loaders", void 0);

    this.loaders = registry.get().map(function (L) {
      return new L(gl);
    });
  }

  _createClass(LoaderResolver, [{
    key: "dispose",
    value: function dispose() {
      this.loaders.forEach(function (l) {
        return l.dispose();
      });
    }
  }, {
    key: "resolve",
    value: function resolve(input) {
      return this.loaders.find(function (loader) {
        return loader.canLoad(input);
      });
    }
  }]);

  return LoaderResolver;
}();

exports.default = LoaderResolver;